// Mock data for FinAssure application

export const mockUser = {
  id: '1',
  name: 'Rajesh Kumar',
  email: 'rajesh.kumar@example.com',
  phone: '+91 98765 43210',
  financialHealthScore: 78,
  profileImage: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Rajesh'
};

export const mockExpenses = [
  { id: '1', date: '2025-01-06', category: 'Food', amount: 450, description: 'Swiggy Order', type: 'expense', source: 'SMS' },
  { id: '2', date: '2025-01-05', category: 'Education', amount: 2500, description: 'Online Course', type: 'expense', source: 'Manual' },
  { id: '3', date: '2025-01-05', category: 'Transport', amount: 180, description: 'Uber Ride', type: 'expense', source: 'SMS' },
  { id: '4', date: '2025-01-04', category: 'Entertainment', amount: 800, description: 'Movie Tickets', type: 'expense', source: 'SMS' },
  { id: '5', date: '2025-01-03', category: 'Shopping', amount: 3200, description: 'Amazon Order', type: 'expense', source: 'SMS' },
  { id: '6', date: '2025-01-03', category: 'Bills', amount: 1500, description: 'Electricity Bill', type: 'expense', source: 'SMS' },
  { id: '7', date: '2025-01-02', category: 'Food', amount: 320, description: 'Restaurant', type: 'expense', source: 'Manual' },
  { id: '8', date: '2025-01-01', category: 'Health', amount: 650, description: 'Pharmacy', type: 'expense', source: 'SMS' }
];

export const mockIncome = [
  { id: '1', date: '2025-01-01', source: 'Salary', amount: 75000, type: 'income' },
  { id: '2', date: '2024-12-28', source: 'Freelance', amount: 15000, type: 'income' }
];

export const mockLoans = [
  // --- HOME LOANS (6 Banks) ---
  {
    id: 'hl1',
    bankName: 'SBI (State Bank of India)',
    loanType: 'Home Loan',
    interestRate: 8.40,
    tenure: '30 years',
    processingFee: '0.35%',
    maxAmount: '₹10 Crore',
    rating: 4.8,
    applyLink: 'https://sbi.co.in/web/personal-banking/loans/home-loans'
  },
  {
    id: 'hl2',
    bankName: 'HDFC Bank',
    loanType: 'Home Loan',
    interestRate: 8.50,
    tenure: '30 years',
    processingFee: '0.5%',
    maxAmount: '₹10 Crore',
    rating: 4.7,
    applyLink: 'https://www.hdfcbank.com/personal/borrow/home-loan'
  },
  {
    id: 'hl3',
    bankName: 'ICICI Bank',
    loanType: 'Home Loan',
    interestRate: 8.60,
    tenure: '30 years',
    processingFee: '0.5%',
    maxAmount: '₹7.5 Crore',
    rating: 4.6,
    applyLink: 'https://www.icicibank.com/personal-banking/loans/home-loan'
  },
  {
    id: 'hl4',
    bankName: 'Axis Bank',
    loanType: 'Home Loan',
    interestRate: 8.75,
    tenure: '30 years',
    processingFee: '1%',
    maxAmount: '₹5 Crore',
    rating: 4.4,
    applyLink: 'https://www.axisbank.com/retail/loans/home-loan'
  },
  {
    id: 'hl5',
    bankName: 'Punjab National Bank',
    loanType: 'Home Loan',
    interestRate: 8.45,
    tenure: '30 years',
    processingFee: '0.35%',
    maxAmount: '₹3 Crore',
    rating: 4.2,
    applyLink: 'https://www.pnbindia.in/en/ui/Home-Loans.aspx'
  },
  {
    id: 'hl6',
    bankName: 'LIC Housing Finance',
    loanType: 'Home Loan',
    interestRate: 8.55,
    tenure: '30 years',
    processingFee: '0.5%',
    maxAmount: '₹10 Crore',
    rating: 4.3,
    applyLink: 'https://www.lichousing.com/home-loan.aspx'
  },

  // --- CAR/VEHICLE LOANS (5 Banks) ---
  {
    id: 'cl1',
    bankName: 'SBI (State Bank of India)',
    loanType: 'Car Loan',
    interestRate: 8.65,
    tenure: '7 years',
    processingFee: 'Nil',
    maxAmount: '₹1.5 Crore',
    rating: 4.7,
    applyLink: 'https://sbi.co.in/web/personal-banking/loans/automobile-loans'
  },
  {
    id: 'cl2',
    bankName: 'HDFC Bank',
    loanType: 'Car Loan',
    interestRate: 8.75,
    tenure: '7 years',
    processingFee: '0.5%',
    maxAmount: '₹75 Lakh',
    rating: 4.6,
    applyLink: 'https://www.hdfcbank.com/personal/borrow/popular-loans/car-loan'
  },
  {
    id: 'cl3',
    bankName: 'ICICI Bank',
    loanType: 'Car Loan',
    interestRate: 8.80,
    tenure: '7 years',
    processingFee: '1%',
    maxAmount: '₹50 Lakh',
    rating: 4.5,
    applyLink: 'https://www.icicibank.com/personal-banking/loans/car-loan'
  },
  {
    id: 'cl4',
    bankName: 'Bank of Baroda',
    loanType: 'Car Loan',
    interestRate: 8.90,
    tenure: '7 years',
    processingFee: '0.75%',
    maxAmount: '₹1 Crore',
    rating: 4.3,
    applyLink: 'https://www.bankofbaroda.in/personal-banking/loans/vehicle-deposit/baroda-car-loan'
  },
  {
    id: 'cl5',
    bankName: 'Kotak Mahindra Bank',
    loanType: 'Car Loan',
    interestRate: 8.85,
    tenure: '5 years',
    processingFee: '1%',
    maxAmount: '₹50 Lakh',
    rating: 4.4,
    applyLink: 'https://www.kotak.com/en/personal-banking/loans/car-loan.html'
  },

  // --- PERSONAL LOANS (8 Banks) ---
  {
    id: 'pl1',
    bankName: 'HDFC Bank',
    loanType: 'Personal Loan',
    interestRate: 10.50,
    tenure: '5 years',
    processingFee: '2.5%',
    maxAmount: '₹40 Lakh',
    rating: 4.7,
    applyLink: 'https://www.hdfcbank.com/personal/borrow/popular-loans/personal-loan'
  },
  {
    id: 'pl2',
    bankName: 'ICICI Bank',
    loanType: 'Personal Loan',
    interestRate: 10.75,
    tenure: '5 years',
    processingFee: '2%',
    maxAmount: '₹50 Lakh',
    rating: 4.6,
    applyLink: 'https://www.icicibank.com/personal-banking/loans/personal-loan'
  },
  {
    id: 'pl3',
    bankName: 'Axis Bank',
    loanType: 'Personal Loan',
    interestRate: 10.49,
    tenure: '5 years',
    processingFee: '2%',
    maxAmount: '₹40 Lakh',
    rating: 4.5,
    applyLink: 'https://www.axisbank.com/retail/loans/personal-loan'
  },
  {
    id: 'pl4',
    bankName: 'Bajaj Finserv',
    loanType: 'Personal Loan',
    interestRate: 11.00,
    tenure: '6 years',
    processingFee: '2%',
    maxAmount: '₹35 Lakh',
    rating: 4.5,
    applyLink: 'https://www.bajajfinserv.in/personal-loan'
  },
  {
    id: 'pl5',
    bankName: 'IDFC FIRST Bank',
    loanType: 'Personal Loan',
    interestRate: 10.99,
    tenure: '5 years',
    processingFee: '1.5%',
    maxAmount: '₹25 Lakh',
    rating: 4.4,
    applyLink: 'https://www.idfcfirstbank.com/personal-banking/loans/personal-loan'
  },
  {
    id: 'pl6',
    bankName: 'Tata Capital',
    loanType: 'Personal Loan',
    interestRate: 10.99,
    tenure: '6 years',
    processingFee: '1.5%',
    maxAmount: '₹35 Lakh',
    rating: 4.3,
    applyLink: 'https://www.tatacapital.com/personal-loan.htm'
  },
  {
    id: 'pl7',
    bankName: 'IndusInd Bank',
    loanType: 'Personal Loan',
    interestRate: 11.25,
    tenure: '5 years',
    processingFee: '2.5%',
    maxAmount: '₹25 Lakh',
    rating: 4.2,
    applyLink: 'https://www.indusind.com/in/en/personal/loans/personal-loan.html'
  },
  {
    id: 'pl8',
    bankName: 'Fullerton India',
    loanType: 'Personal Loan',
    interestRate: 11.99,
    tenure: '5 years',
    processingFee: '3%',
    maxAmount: '₹25 Lakh',
    rating: 4.1,
    applyLink: 'https://www.fullertonindia.com/personal-loan.aspx'
  },

  // --- EDUCATION LOANS (3 Banks) ---
  {
    id: 'el1',
    bankName: 'SBI (State Bank of India)',
    loanType: 'Education Loan',
    interestRate: 8.65,
    tenure: '15 years',
    processingFee: 'Nil',
    maxAmount: '₹1.5 Crore',
    rating: 4.9,
    applyLink: 'https://sbi.co.in/web/personal-banking/loans/education-loans'
  },
  {
    id: 'el2',
    bankName: 'HDFC Credila',
    loanType: 'Education Loan',
    interestRate: 9.00,
    tenure: '15 years',
    processingFee: '1%',
    maxAmount: '₹1 Crore',
    rating: 4.5,
    applyLink: 'https://www.hdfccredila.com/'
  },
  {
    id: 'el3',
    bankName: 'Union Bank of India',
    loanType: 'Education Loan',
    interestRate: 9.30,
    tenure: '15 years',
    processingFee: 'Nil',
    maxAmount: '₹40 Lakh',
    rating: 4.2,
    applyLink: 'https://www.unionbankofindia.co.in/english/education-loan.aspx'
  },

  // --- BUSINESS LOANS (2 Banks) ---
  {
    id: 'bl1',
    bankName: 'HDFC Bank',
    loanType: 'Business Loan',
    interestRate: 12.00,
    tenure: '5 years',
    processingFee: '2%',
    maxAmount: '₹50 Lakh',
    rating: 4.6,
    applyLink: 'https://www.hdfcbank.com/sme/products/business-loans'
  },
  {
    id: 'bl2',
    bankName: 'ICICI Bank',
    loanType: 'Business Loan',
    interestRate: 12.25,
    tenure: '5 years',
    processingFee: '2%',
    maxAmount: '₹75 Lakh',
    rating: 4.5,
    applyLink: 'https://www.icicibank.com/business-banking/loans/business-loan'
  }
];

export const mockFixedDeposits = [
  {
    id: '1',
    bankName: 'SBI',
    interestRate: 7.1,
    tenure: '5 years',
    minAmount: '₹1,000',
    rating: 4.5,
    taxSaving: true
  },
  {
    id: '2',
    bankName: 'HDFC Bank',
    interestRate: 7.0,
    tenure: '5 years',
    minAmount: '₹5,000',
    rating: 4.4,
    taxSaving: true
  },
  {
    id: '3',
    bankName: 'Post Office',
    interestRate: 7.5,
    tenure: '5 years',
    minAmount: '₹1,000',
    rating: 4.7,
    taxSaving: true
  }
];

export const mockMutualFunds = [
  // --- LARGE CAP FUNDS ---
  {
    id: '1',
    fundName: 'Axis Bluechip Fund',
    category: 'Large Cap',
    returns1Y: 18.5,
    returns3Y: 22.3,
    returns5Y: 19.8,
    minInvestment: '₹100',
    expenseRatio: 0.48,
    rating: 5
  },
  {
    id: '2',
    fundName: 'Mirae Asset Large Cap Fund',
    category: 'Large Cap',
    returns1Y: 19.2,
    returns3Y: 21.8,
    returns5Y: 18.9,
    minInvestment: '₹1,000',
    expenseRatio: 0.52,
    rating: 5
  },
  {
    id: '13',
    fundName: 'ICICI Prudential Bluechip Fund',
    category: 'Large Cap',
    returns1Y: 17.8,
    returns3Y: 20.5,
    returns5Y: 18.2,
    minInvestment: '₹1,000',
    expenseRatio: 0.82,
    rating: 4
  },

  // --- FL EXI CAP / MULTI CAP ---
  {
    id: '3',
    fundName: 'Parag Parikh Flexi Cap',
    category: 'Flexi Cap',
    returns1Y: 28.7,
    returns3Y: 31.2,
    returns5Y: 26.4,
    minInvestment: '₹1,000',
    expenseRatio: 0.68,
    rating: 5
  },
  {
    id: '4',
    fundName: 'Kotak Flexicap Fund',
    category: 'Flexi Cap',
    returns1Y: 20.1,
    returns3Y: 24.5,
    returns5Y: 21.3,
    minInvestment: '₹1,000',
    expenseRatio: 0.61,
    rating: 4
  },
  {
    id: '14',
    fundName: 'JM Flexicap Fund',
    category: 'Flexi Cap',
    returns1Y: 21.5,
    returns3Y: 25.8,
    returns5Y: 22.1,
    minInvestment: '₹5,000',
    expenseRatio: 0.71,
    rating: 4
  },

  // --- LARGE & MID CAP ---
  {
    id: '5',
    fundName: 'Mirae Asset Emerging Bluechip',
    category: 'Large & Mid Cap',
    returns1Y: 24.3,
    returns3Y: 27.8,
    returns5Y: 23.1,
    minInvestment: '₹1,000',
    expenseRatio: 0.56,
    rating: 5
  },
  {
    id: '6',
    fundName: 'Canara Robeco Emerging Equities',
    category: 'Large & Mid Cap',
    returns1Y: 22.4,
    returns3Y: 26.2,
    returns5Y: 22.8,
    minInvestment: '₹5,000',
    expenseRatio: 0.72,
    rating: 4
  },

  // --- MID CAP ---
  {
    id: '7',
    fundName: 'Motilal Oswal Midcap Fund',
    category: 'Mid Cap',
    returns1Y: 32.5,
    returns3Y: 35.8,
    returns5Y: 28.9,
    minInvestment: '₹500',
    expenseRatio: 0.75,
    rating: 5
  },
  {
    id: '8',
    fundName: 'Quant Mid Cap Fund',
    category: 'Mid Cap',
    returns1Y: 35.2,
    returns3Y: 38.1,
    returns5Y: 30.4,
    minInvestment: '₹5,000',
    expenseRatio: 0.69,
    rating: 5
  },
  {
    id: '15',
    fundName: 'Edelweiss Mid Cap Fund',
    category: 'Mid Cap',
    returns1Y: 30.8,
    returns3Y: 33.5,
    returns5Y: 27.6,
    minInvestment: '₹1,000',
    expenseRatio: 0.78,
    rating: 4
  },

  // --- SMALL CAP ---
  {
    id: '9',
    fundName: 'Nippon India Small Cap Fund',
    category: 'Small Cap',
    returns1Y: 38.6,
    returns3Y: 42.3,
    returns5Y: 32.7,
    minInvestment: '₹1,000',
    expenseRatio: 0.79,
    rating: 5
  },
  {
    id: '10',
    fundName: 'Axis Small Cap Fund',
    category: 'Small Cap',
    returns1Y: 36.8,
    returns3Y: 40.5,
    returns5Y: 31.2,
    minInvestment: '₹100',
    expenseRatio: 0.64,
    rating: 4
  },
  {
    id: '16',
    fundName: 'SBI Small Cap Fund',
    category: 'Small Cap',
    returns1Y: 35.2,
    returns3Y: 39.1,
    returns5Y: 30.5,
    minInvestment: '₹5,000',
    expenseRatio: 0.73,
    rating: 4
  },
  {
    id: '17',
    fundName: 'Kotak Small Cap Fund',
    category: 'Small Cap',
    returns1Y: 37.5,
    returns3Y: 41.2,
    returns5Y: 31.8,
    minInvestment: '₹1,000',
    expenseRatio: 0.71,
    rating: 5
  },

  // --- HYBRID / BALANCED ---
  {
    id: '11',
    fundName: 'ICICI Prudential Equity & Debt Fund',
    category: 'Hybrid',
    returns1Y: 15.2,
    returns3Y: 18.5,
    returns5Y: 16.8,
    minInvestment: '₹5,000',
    expenseRatio: 1.05,
    rating: 4
  },
  {
    id: '18',
    fundName: 'HDFC Hybrid Equity Fund',
    category: 'Hybrid',
    returns1Y: 14.8,
    returns3Y: 17.9,
    returns5Y: 16.2,
    minInvestment: '₹5,000',
    expenseRatio: 1.12,
    rating: 4
  },

  // --- DEBT FUND ---
  {
    id: '12',
    fundName: 'HDFC Corporate Bond Fund',
    category: 'Debt',
    returns1Y: 7.2,
    returns3Y: 7.8,
    returns5Y: 7.5,
    minInvestment: '₹5,000',
    expenseRatio: 0.42,
    rating: 4
  },
  {
    id: '19',
    fundName: 'ICICI Prudential Corporate Bond Fund',
    category: 'Debt',
    returns1Y: 7.5,
    returns3Y: 8.1,
    returns5Y: 7.7,
    minInvestment: '₹5,000',
    expenseRatio: 0.39,
    rating: 4
  },

  // --- ELSS (Tax Saving) ---
  {
    id: '20',
    fundName: 'Axis Long Term Equity Fund (ELSS)',
    category: 'ELSS',
    returns1Y: 20.5,
    returns3Y: 24.8,
    returns5Y: 21.2,
    minInvestment: '₹500',
    expenseRatio: 0.68,
    rating: 5
  }
];

export const mockPortfolio = [
  {
    id: '1',
    assetType: 'Stocks',
    assetName: 'Reliance Industries',
    ticker: 'RELIANCE.NS',
    quantity: 50,
    buyPrice: 2450,
    buyDate: '2023-06-15',
    currentPrice: 2680,
    totalInvested: 122500,
    currentValue: 134000,
    profitLoss: 11500,
    profitLossPercent: 9.39
  },
  {
    id: '2',
    assetType: 'Mutual Fund',
    assetName: 'Axis Bluechip Fund',
    ticker: 'AXISBLUE',
    quantity: 1000,
    buyPrice: 45,
    buyDate: '2022-01-20',
    currentPrice: 52.3,
    totalInvested: 45000,
    currentValue: 52300,
    profitLoss: 7300,
    profitLossPercent: 16.22
  },
  {
    id: '3',
    assetType: 'Fixed Deposit',
    assetName: 'SBI FD',
    ticker: null,
    quantity: 1,
    buyPrice: 100000,
    buyDate: '2021-11-01',
    interestRate: 7.1, // % per annum
    maturityDate: '2026-11-01',
    currentPrice: 107100, // This will be dynamic in the component
    totalInvested: 100000,
    currentValue: 107100,
    profitLoss: 7100,
    profitLossPercent: 7.1
  }
];

export const mockNews = [
  {
    id: '1',
    title: 'RBI keeps repo rate unchanged at 6.5% for sixth consecutive time',
    source: 'Economic Times',
    time: '2 hours ago',
    url: '#'
  },
  {
    id: '2',
    title: 'Nifty hits new all-time high, crosses 22,000 mark',
    source: 'Moneycontrol',
    time: '4 hours ago',
    url: '#'
  },
  {
    id: '3',
    title: 'Gold prices surge to ₹68,500 per 10 grams',
    source: 'Business Standard',
    time: '6 hours ago',
    url: '#'
  },
  {
    id: '4',
    title: 'Indian mutual funds attract record inflows in December',
    source: 'Livemint',
    time: '8 hours ago',
    url: '#'
  }
];

export const mockReminders = [
  {
    id: '1',
    title: 'Credit Card Bill Payment',
    dueDate: '2025-01-10',
    amount: 12500,
    status: 'pending',
    type: 'bill'
  },
  {
    id: '2',
    title: 'SIP - Axis Bluechip Fund',
    dueDate: '2025-01-05',
    amount: 5000,
    status: 'completed',
    type: 'investment'
  },
  {
    id: '3',
    title: 'Home Loan EMI',
    dueDate: '2025-01-15',
    amount: 28000,
    status: 'pending',
    type: 'emi'
  }
];

export const mockConsultants = [
  {
    id: '1',
    name: 'Priya Sharma',
    expertise: 'Investment Planning',
    experience: '8 years',
    rating: 4.8,
    consultations: 450,
    fee: '₹1,500/hour',
    image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Priya',
    available: true
  },
  {
    id: '2',
    name: 'Amit Patel',
    expertise: 'Tax Planning',
    experience: '12 years',
    rating: 4.9,
    consultations: 780,
    fee: '₹2,000/hour',
    image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Amit',
    available: true
  },
  {
    id: '3',
    name: 'Sneha Reddy',
    expertise: 'Retirement Planning',
    experience: '10 years',
    rating: 4.7,
    consultations: 620,
    fee: '₹1,800/hour',
    image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sneha',
    available: false
  }
];

export const mockSavingsSuggestions = [
  {
    id: '1',
    category: 'Food Delivery',
    currentSpending: 8500,
    suggestedSpending: 5000,
    potentialSavings: 3500,
    tip: 'Reduce food delivery orders and cook at home 3-4 times a week'
  },
  {
    id: '2',
    category: 'Subscriptions',
    currentSpending: 2500,
    suggestedSpending: 1200,
    potentialSavings: 1300,
    tip: 'Cancel unused subscriptions - Netflix, Spotify, Gym membership'
  },
  {
    id: '3',
    category: 'Entertainment',
    currentSpending: 4500,
    suggestedSpending: 2500,
    potentialSavings: 2000,
    tip: 'Limit movie outings and explore free entertainment options'
  }
];

export const mockCategoryData = [
  { category: 'Food', amount: 8500, percentage: 28, color: '#10b981' },
  { category: 'Transport', amount: 3200, percentage: 11, color: '#3b82f6' },
  { category: 'Shopping', amount: 6800, percentage: 23, color: '#f59e0b' },
  { category: 'Bills', amount: 4500, percentage: 15, color: '#ef4444' },
  { category: 'Entertainment', amount: 2500, percentage: 8, color: '#8b5cf6' },
  { category: 'Education', amount: 2500, percentage: 8, color: '#ec4899' },
  { category: 'Health', amount: 2000, percentage: 7, color: '#14b8a6' }
];